import { useUser } from "context/AuthContext";
import default_avatar from "img/default-avatar.png";
import "./user-widget.scss"; 

export default function UserWidget({ onClick }: {
   onClick: () => void;
}) {

   const user = useUser();

   return (
      <div className="user-widget" onClick={ onClick }>
         <img src={ default_avatar }/>
         <span> { user.name } </span>
      </div>
   )
}